import React from 'react';

import Delete from 'Components/Partials/Modals/Delete';
import {IndexTable} from 'Components/Utilities';

import AdminLayout from 'Pages/Admin/AdminLayout';

import AdminExhibitorsApi from 'Services/Api/Admin/Exhibitors';

export default class ExhibitorsIndex extends React.Component {
    /**
     * @var state
     */
    state = {
        columns: null
    };

    /**
     * @method componentDidMount
     */
    componentDidMount() {
        this.setColumns();
    }

    /**
     * @method setColumns
     */
    setColumns = () => {
        let columns = [
            {
                label: 'Name',
                value: 'name',
                type: 'string',
                orderable: 'name'
            }
        ];

        if (window.base.exhibitor_zones) {
            columns.push({
                label: 'Zone',
                value: 'zone',
                type: 'string',
                orderable: 'Zone'
            });
        }

        if (Object.keys(window.base.languages).length > 1) {
            columns.push({
                label: 'Supported Languages',
                value: (record) => record.supported_languages && record.supported_languages.map((language, key) => {
                    let string = window.base.languages[language];

                    if (key !== (record.supported_languages.length - 1)) {
                        string += ', ';
                    }

                    return string;
                }),
                type: 'callback',
                orderable: null,
            });
        }

        columns.push({
            label: 'Email',
            value: 'email',
            type: 'string',
            orderable: 'email'
        });

        this.setState({
            columns
        });
    }

    /**
     * @method getRowActions
     * @param {object} item
     */
    getRowActions = (item) => {
        return [
            {
                type: "link",
                to: "/exhibitors/"+item.id,
                text: "View",
                target: "_blank"
            },
            {
                type: "link",
                to: "/admin/exhibitors/store/"+item.id,
                text: "Update"
            },
            {
                type: "modalTrigger",
                component: Delete,
                props: {
                    message: `Are you sure you want to delete this Exhibitor? 
                        Deleting this exhibitor will delete all connected bookings, messages and quiz submissions.
                        You can deactivate the exhibitor instead, to prevent it from displaying
                        on the site but preserve any connected data.`,
                    itemId: item.id,
                    onDeleteApi: AdminExhibitorsApi.delete
                },
                text: 'Delete'
            }
        ];
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {columns} = this.state;

        return (
            <AdminLayout title="Admin Exhibitors">
                {columns &&
                    <IndexTable
                        columns={columns}
                        displaySearchBar={false}
                        storeLink="/admin/exhibitors/store"
                        loadDataCallback={(data) => AdminExhibitorsApi.get(null, data)}
                        rowActions={this.getRowActions}
                        eventApi={AdminExhibitorsApi}
                    />
                }
            </AdminLayout>
        )
    }
}